type Tone = 'neutral' | 'good' | 'warn' | 'bad' | 'info'

const TONES: Record<Tone, string> = {
  neutral: 'bg-slate-100 text-slate-700',
  good: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300',
  warn: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300',
  bad: 'bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300',
  info: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-950 dark:text-indigo-300',
}

/**
 * A state, said in colour as well as in words.
 *
 * <p>Colour alone is not the signal — the label is always present — but a console that is
 * scanned rather than read needs "suspended" and "active" to separate before either is read.
 */
export function StatusPill({ tone, children }: { tone: Tone; children: React.ReactNode }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${TONES[tone]}`}
    >
      {children}
    </span>
  )
}

export function invoiceTone(status: string): Tone {
  switch (status) {
    case 'PAID':
      return 'good'
    case 'ISSUED':
      return 'info'
    case 'VOID':
      return 'bad'
    default:
      return 'neutral'
  }
}

export function operatorTone(status: string, canSignIn: boolean): Tone {
  if (status === 'DISABLED') return 'bad'
  return canSignIn ? 'good' : 'warn'
}
